<h2 mat-dialog-title>Gestión de UF y Personas</h2>

<div mat-dialog-content>

  <form [formGroup]="formGroup">

    <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Nro. UF</b>: {{input?.UnidadFuncionalNumero}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>
      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label *ngIf="!isTipoRelacionSearching">Relación*</mat-label>
          <mat-label *ngIf="isTipoRelacionSearching">Cargando...</mat-label>
          <mat-select formControlName="TipoRelacion" (selectionChange)="onTipoRelacionSelect()">
            <mat-option *ngFor="let s of tipoRelacionList" [value]="s">{{s.Nombre}}</mat-option>
          </mat-select>
          <mat-error *ngIf="!formGroup.controls['TipoRelacion'].valid && formGroup.controls['TipoRelacion'].touched">
            {{ getErrorTipoRelacion() }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Persona
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff;">
                <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                  <mat-label>
                    ¿Ya tenes cargados los datos de la persona para asociarlos a esta UF?
                  </mat-label>
                </div>
                <br/>
                <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                  <button mat-raised-button (click)="onPersonSearchClick()" color="accent" class="zb-button">Buscar Datos de Persona Existente</button>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b># Persona</b>: {{(formGroup.get('PersonaId')?.value > 0 ? formGroup.get('PersonaId')?.value : 'NUEVO')}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" style="margin-top: 5px;">
              <button mat-raised-button (click)="onPersonDeassociateClick()" color="warn" class="zb-button">
                Cargar como Nueva Persona
              </button>
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Mail de Persona*</mat-label>
                <input matInput type="email" formControlName="PersonaMailContacto" maxlength="255" (change)="checkPersonaExistance()">
                <mat-error *ngIf="!formGroup.controls['PersonaMailContacto'].valid && formGroup.controls['PersonaMailContacto'].touched">
                  {{ getErrorPersonaMailContacto() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre de Persona*</mat-label>
                <input matInput type="text" formControlName="PersonaNombre" maxlength="150">
                <mat-error *ngIf="!formGroup.controls['PersonaNombre'].valid && formGroup.controls['PersonaNombre'].touched">
                  {{ getErrorPersonaNombre() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=34 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Apellido de Persona*</mat-label>
                <input matInput type="text" formControlName="PersonaApellido" maxlength="150">
                <mat-error *ngIf="!formGroup.controls['PersonaApellido'].valid && formGroup.controls['PersonaApellido'].touched">
                  {{ getErrorPersonaApellido() }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
              <mat-checkbox [(ngModel)]="enviarInvitacion" *ngIf="formGroup.get('PuedeEnviarInvitacion').value == true" 
                (keyup.enter)="onGuardar()" [ngModelOptions]="{standalone: true}" color="primary">Enviar invitación para el sistema</mat-checkbox> 
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
              <mat-checkbox [(ngModel)]="enviarExpensa" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas" 
                (keyup.enter)="onGuardar()" [ngModelOptions]="{standalone: true}" color="primary">Enviar liquidación de expensas</mat-checkbox> 
            </div>
          </div>

        </mat-expansion-panel>

      </div>

    </div>

  </form>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="primary" (click)="onGuardar()" class="zb-button">
      {{isPersonaSaving ? 'Cargando...' : 'Cargar Datos'}}
    </button>
    <button mat-raised-button color="warn" (click)="onCancel()" class="zb-button">Cancelar</button>
  </div>
</div>